import { useAppTakeover } from './use-app-takeover';
import type { AppTakeoverType } from './use-app-takeover';

export const useAppTakeoverCart = (): Partial<
  AppTakeoverType['cart'] & {
    isTakeoverActive: boolean;
    hasPaymentProcessingTakeover: boolean;
    fontFamily?: string;
  }
> => {
  const appTakeover = useAppTakeover();

  if (appTakeover?.cart) {
    return {
      ...appTakeover?.cart,
      isTakeoverActive: true,
      hasPaymentProcessingTakeover: !!appTakeover?.cart?.paymentProcessingVideo,
      fontFamily: appTakeover.fontFamily,
    };
  }

  return { isTakeoverActive: false };
};
